"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AServiceServer = exports.AServiceClient = void 0;
class AServiceClient {
    constructor(transport, protocol) {
        this.transport = transport;
        this.protocol = protocol;
    }
    async connect(timeout) {
        await this.transport.connect(timeout);
    }
    async close() {
        await this.transport.close();
    }
}
exports.AServiceClient = AServiceClient;
class AServiceServer {
    constructor(transport, protocol, announcer, endpoint) {
        this.transport = transport;
        this.protocol = protocol;
        this.announcer = announcer;
        this.endpoint = endpoint;
        this.isRunning = false;
        this.runningTask = null;
        this.announcerTask = null;
    }
    async start() {
        await this.transport.listen();
        this.isRunning = true;
        this.runningTask = this.serverHandler();
        if (this.announcer && this.endpoint) {
            await this.announcer.register(this.endpoint);
            this.announcerTask = this.announcerHandler();
        }
    }
    async run() {
        await this.start();
        await this.runningTask;
    }
    async stop() {
        this.isRunning = false;
        await this.transport.close();
        await this.runningTask;
    }
    async serverHandler() {
        while (this.isRunning) {
            try {
                await this.handleRequest();
            }
            catch (err) {
                console.error(err.toString());
            }
        }
    }
    async announcerHandler() {
        if (!this.announcer)
            return;
        if (!this.endpoint)
            return;
        while (this.isRunning) {
            try {
                await delay(10000);
                await this.announcer.register(this.endpoint);
            }
            catch (err) {
                console.error(err.toString());
            }
        }
    }
}
exports.AServiceServer = AServiceServer;
function delay(ms) {
    return new Promise((resolve) => setTimeout(() => resolve(), ms));
}
